import React from 'react';
import { useHistory } from 'react-router-dom';

export interface BreadcrumbItem {
    label: string;
    to?: string;
}

interface DetailBreadcrumbProps {
    items: BreadcrumbItem[];
}

const DetailBreadcrumb: React.FC<DetailBreadcrumbProps> = ({ items }) => {

    const history = useHistory();

    return (
        <nav className="detail-breadcrumb">
            {items.map((item, index) => {
                const isLast = index === items.length - 1;
                return (
                    <React.Fragment key={index}>
                        {index > 0 && <span className="detail-breadcrumb__sep">/</span>}
                        {!isLast && item.to ? (
                            <button
                                type="button"
                                className="detail-breadcrumb__link"
                                onClick={() => history.push(item.to!)}
                            >
                                {item.label}
                            </button>
                        ) : (
                            <span className="detail-breadcrumb__current">{item.label}</span>
                        )}
                    </React.Fragment>
                );
            })}
        </nav>
    );

};

export default React.memo(DetailBreadcrumb);
